/**
 * 生小孩h5首页
 */
import { updateShareInfo } from '@tencent/h5-share-enhance';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getValue, shareTraceAndChannelLink } from '../../lib/utils/beacon';
import { updateCurPageAction, updateSelectedMaterialAction, } from '../../lib/common/store/reducer/actions';
import { setAutoDetectFace, setFatherCropImg, setFatherOriginImg, setMotherCropImg, setMotherOriginImg, } from '../../lib/common/store/reducer/h5-baby';
import IndexPage from '../../lib/components/Pages/IndexPage';
import { generateCommonData } from '../H5ChristmasIndexPage/h5-config';
import style from './index.module.scss';
const H5BabyIndexPage = ({ data: { backgroundImageUrl, playBtnUrl, logoUrl, titleUrl, contentUrl, materialConfigList, privacyCheckedImgUrl, privacyTitle, privacyContent, bottomLogoUrl, contentGifUrl, }, meta, global, }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateSelectedMaterialAction(materialConfigList));
        dispatch(setFatherCropImg(''));
        dispatch(setMotherCropImg(''));
        dispatch(setFatherOriginImg(''));
        dispatch(setMotherOriginImg(''));
        const commonData = generateCommonData(global);
        const shareUrl = `https://${window.location.host}${window.location.pathname}?source=link&${shareTraceAndChannelLink('link')}`;
        updateShareInfo({
            description: meta.desc,
            title: meta.title,
            imgUrl: materialConfigList.thumbnailImageUrl,
            link: shareUrl,
            sourceName: commonData.qqSource,
        });
        dispatch(setAutoDetectFace(getValue('EXPERIMENT_ID') === 'auto_face'));
    }, []);
    const handleClickAction = () => {
        dispatch(updateCurPageAction('choose_image'));
    };
    const getActionBtn = () => (React.createElement("div", { className: style['action-panel'] },
        React.createElement("img", { src: playBtnUrl, alt: "", onClick: handleClickAction, "data-btn-id": "index#play-btn" })));
    return (React.createElement("div", { className: style['baby-container'], style: { backgroundImage: `url(${backgroundImageUrl})` } },
        React.createElement(IndexPage, { actionBtnContent: getActionBtn(), isPrivacy: true, isChooseImageModal: false, privacyCheckedImgUrl: privacyCheckedImgUrl, bottomLogoUrl: bottomLogoUrl, privacyTitle: privacyTitle, privacyContent: privacyContent },
            React.createElement("div", { className: style.logo },
                React.createElement("img", { src: logoUrl, alt: "" })),
            React.createElement("div", { className: style.indexSection },
                React.createElement("div", { className: style.title },
                    React.createElement("img", { src: titleUrl, alt: "" })),
                React.createElement("div", { className: style.content },
                    React.createElement("img", { src: contentUrl, alt: "" }),
                    React.createElement("img", { src: contentUrl, alt: "" }),
                    contentGifUrl ? (React.createElement("img", { src: contentGifUrl, alt: "", className: style['ani-content'] })) : null)))));
};
export default H5BabyIndexPage;
